const YojanaSections = ({
  children,
  options,
  activeSection,
  setActiveSection,
  language = false,
}) => {
  return (
    <div className="max-w-[80%] mx-auto grid grid-cols-1 md:grid-cols-12 gap-4 px-4 py-10 bg-white">
      <div className="md:col-span-3 rounded-lg shadow p-4 h-fit sticky top-24">
        <div className="space-y-2">
          {options.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveSection(item.id)}
              className={`w-full text-left px-3 py-2 rounded-md transition
                      ${
                        activeSection === item.id
                          ? "bg-btn text-white font-semibold"
                          : "hover:bg-gray-100 text-gray-700"
                      }`}
            >
              {language ? item.label.hi : item.label.en}
            </button>
          ))}
        </div>
      </div>
      <div className="md:col-span-9 bg-white rounded-lg shadow p-6">{children}</div>
    </div>
  );
};

export default YojanaSections;
